var _rect, _rect2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMoney(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 24,
    viewBox: "0 0 42 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 24,
    rx: 6,
    fill: "#27CD31"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.25,
    y: 3,
    width: 31.5,
    height: 18,
    fill: "white"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 21,
    cy: 12,
    rx: 6.125,
    ry: 7,
    fill: "#27CD31"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.25,
    cy: 3,
    rx: 2.625,
    ry: 3,
    fill: "#27CD31"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.75,
    cy: 3,
    rx: 2.625,
    ry: 3,
    fill: "#27CD31"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 36.75,
    cy: 21,
    rx: 2.625,
    ry: 3,
    fill: "#27CD31"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.25,
    cy: 21,
    rx: 2.625,
    ry: 3,
    fill: "#27CD31"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.386 7.2C23.2073 7.2 23.926 7.28867 24.542 7.466V9.496C24.5047 9.47733 24.4113 9.44 24.262 9.384C24.1127 9.328 23.9073 9.27667 23.646 9.23C23.394 9.174 23.1187 9.146 22.82 9.146C22.2227 9.146 21.7187 9.26733 21.308 9.51C20.8973 9.75267 20.5893 10.098 20.384 10.546H23.31V11.848H20.076V12.156C20.076 12.324 20.0807 12.4453 20.09 12.52H23.31V13.822H20.398C20.6127 14.27 20.9207 14.6153 21.322 14.858C21.7327 15.1007 22.232 15.222 22.82 15.222C23.1187 15.222 23.394 15.194 23.646 15.138C23.9073 15.082 24.1127 15.026 24.262 14.97C24.4113 14.9047 24.5047 14.8627 24.542 14.844V16.818C23.786 17.0513 23.0533 17.168 22.344 17.168C21.6907 17.168 21.0373 17.0653 20.384 16.86C19.74 16.6453 19.1567 16.2907 18.634 15.796C18.1113 15.292 17.738 14.634 17.514 13.822H16.072V12.52H17.332V11.848H16.072V10.546H17.514C17.8407 9.36067 18.4567 8.50667 19.362 7.984C20.2767 7.46133 21.2847 7.2 22.386 7.2Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/Money.2edc4012424a21cc281841156d9446b5.svg";
export { ForwardRef as ReactComponent };